export default __webpack_public_path__ + "static/media/addhome.df0630aa.svg";